import { Button, Card, Col, Row } from "react-bootstrap";
import pdfAvisoPrivacidade from "../../assets/Pdf/Aviso_de_privacidade_Flex_Consulta_2026.pdf";
import pdfPoliticaDireitoTitulares from "../../assets/Pdf/Politica_de_direito_dos_titulares_Flex_V1.2.pdf";
import pdfTermosUsoFlex from "../../assets/Pdf/Termos_de_Uso_flex_consulta_V1.2.pdf";
import logoFlex from "../../assets/logoflexlaranjaprimario.png";

import { useNavigate } from "react-router-dom";
import { MdOutlineArrowBack } from "react-icons/md";
import { FaFileContract, FaScaleBalanced, FaUserShield } from "react-icons/fa6";

import "./styles.css";

const PortalPrivacidade = () => {
  const navigate = useNavigate();

  return (
    <div style={{ width: "100vw", height: "100vh" }} className="p-5">
      <Row className="d-flex align-items-center justify-content-center">
        <Col>
          <Button
            onClick={() => navigate(-1)}
            variant="outline-primary"
            className="rounded-pill d-flex- align-items-center gap-2"
          >
            <MdOutlineArrowBack size={20} />
            <span>Voltar</span>
          </Button>
        </Col>
      </Row>

      <Row>
        <Col className="d-flex flex-column align-items-center justify-content-center">
          <img alt="logo_flex" src={logoFlex} className="logo_flex" />
          <h2 className="fw-bold">Portal de Privacidade</h2>
          <p className="text-muted fw-lighter">
            Acesse aqui os nossos avisos, políticas e termos sobre o tratamento
            de dados pessoais.
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex align-items-center justify-content-center gap-3 gap-lg-5 mt-4">
          <Card
            className="card_terms"
            onClick={() => {
              window.open(pdfAvisoPrivacidade, "_blank");
            }}
          >
            <FaUserShield size={50} />
            <p>Aviso de Privacidade</p>
          </Card>

          <Card
            className="card_terms"
            onClick={() => {
              window.open(pdfPoliticaDireitoTitulares, "_blank");
            }}
          >
            <FaScaleBalanced size={50} />
            <p>Política de Direitos dos Titulares</p>
          </Card>

          <Card
            className="card_terms"
            onClick={() => {
              window.open(pdfTermosUsoFlex, "_blank");
            }}
          >
            <FaFileContract size={50} />

            <p>Termos de Uso</p>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PortalPrivacidade;
